import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { TypedMemo } from '../../../common/types';
import { useSMLTheme } from '../../theme/useSMLTheme';
import { ReactComponent as MarkOnDark } from '../../../../assets/images/songsbrew/songsbrew-mark-on-dark.svg';
import { ReactComponent as MarkOnLight } from '../../../../assets/images/songsbrew/songsbrew-mark-on-light.svg';
import styles from './SongsBrewMark.module.scss';

export type SongsBrewMarkSize = 'md' | 'sm' | 'xs';

interface Props {
  size?: SongsBrewMarkSize;
  /** The green tick of the done Home card (design: songsbrew-promotion a4). */
  isDone?: boolean;
  className?: string;
}

/**
 * The SongsBrew press-kit mark in its small cream tile (design: songsbrew-promotion sb-mk). The
 * light theme gets the on-light colours. The mark is decoration: the text next to it names it.
 */
const SongsBrewMarkComponent: React.FC<Props> = ({ size = 'md', isDone = false, className }) => {
  const { theme } = useSMLTheme();
  const Mark = theme === 'light' ? MarkOnLight : MarkOnDark;
  return (
    <span
      className={clsx(
        styles.mark,
        theme === 'light' && styles.light,
        size === 'sm' && styles.sm,
        size === 'xs' && styles.xs,
        className
      )}
      aria-hidden="true"
    >
      <Mark className={styles.image} />
      {isDone && (
        <span className={styles.done}>
          <FontAwesomeIcon icon={faCheck} />
        </span>
      )}
    </span>
  );
};

export const SongsBrewMark = TypedMemo(SongsBrewMarkComponent);
